import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { ConverterService, RouterState, RoutingService, StateUtils } from '@spartacus/core';
import { TrackingDelivery, TrackingDeliveryApi } from '@tracking/const';
import { StateWithTracking, TrackingActions, TrackingDeliverySelectors } from '@tracking/data-access';
import { TMS_TRACKING_API_NORMALIZER } from '@tracking/utils';
import { Observable } from 'rxjs';
import { distinctUntilChanged, filter, map, switchMap, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class TrackingDeliveryService {
  constructor(
    private store: Store<StateWithTracking>,
    private routingService: RoutingService,
    private converterService: ConverterService,
  ) {}

  load(id: string): void {
    this.store.dispatch(new TrackingActions.TrackingDeliveryLoad(id));
  }

  loadByQueryParams(): void {
    this.getTrackingIdFromQueryParams()
      .pipe(take(1), filter<string>(Boolean))
      .subscribe((id) => {
        this.load(id);
      });
  }

  getTrackingState(id: string): Observable<StateUtils.LoaderState<TrackingDelivery>> {
    return this.store.select(TrackingDeliverySelectors.getTrackingDelivery(id)).pipe(
      map((state) => ({
        ...state,
        // Конвертируем не сразу при запросе, так как всякие new Date плохо дружать с трансфер стейтом из SSR
        value:
          state.value &&
          this.converterService.convert<TrackingDeliveryApi, TrackingDelivery>(
            state.value,
            TMS_TRACKING_API_NORMALIZER,
          ),
      })),
    );
  }

  getTrackingIdFromQueryParams(): Observable<string | undefined> {
    return this.routingService.getRouterState().pipe(
      map((state: RouterState) => state.state.queryParams['id']),
      distinctUntilChanged(),
    );
  }

  getTrackingStateByQueryParams(): Observable<StateUtils.LoaderState<TrackingDelivery>> {
    return this.getTrackingIdFromQueryParams().pipe(
      filter<string>(Boolean),
      switchMap((id) => this.getTrackingState(id)),
    );
  }
}
